<template>
  <v-container
    fluid
    class="pa-0 header-wrapper d-flex flex-column justify-center align-center"
  >
    <SearchBar isHome="true" />

    <div class="image-overlay-container">
      <img src="../assets/images/bg-header.jpg" class="image-background" />
      <v-overlay absolute opacity="0.9" color="white" />
    </div>

    <div class="content-bottom-center">
      <v-chip color="white" variant="flat" class="custom-chip">
        <span class="text-chip">PORTAL DE MANUAIS TIGRE</span>
      </v-chip>
      <h1 class="text-center mb-4 mt-6 header-title">
        Encontre o manual certo,
        <br />no momento exato.
      </h1>
      <p class="text-subtitle text-center header-subtitle">
        Acesse rapidamente instruções, vídeos e manuais técnicos dos produtos
        Tigre. Tudo em um só lugar, de forma simples e intuitiva.
      </p>
    </div>

    <div class="bottom-border-effect" />
  </v-container>
</template>

<script setup>
import SearchBar from "@/components/SearchBar.vue";
</script>

<style scoped>
.header-wrapper {
  position: relative;
  height: 696px;
  min-height: 696px;
}

.text-chip {
  font-weight: 400;
  font-size: 14px;
  font-family: "Ubuntu", sans-serif;
  line-height: 22px;
  background: linear-gradient(90deg, #fb631a, #fc901f);
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent;
}

.image-overlay-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}

.image-overlay-container::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 80%;
  bottom: 0;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to top, white 35%, rgba(255, 255, 255, 0) 70%);
}

.image-overlay-container::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 80%;
  top: 0;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to bottom, white 0%, rgba(255, 255, 255, 0) 50%);
}

.image-background {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(1.2);
}

.content-bottom-center {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 5;
  width: 90%;
  max-width: 800px;
}

.header-title {
  color: #102954;
  font-family: "Ubuntu", sans-serif;
  font-weight: 700 !important;
  font-size: 32px;
  line-height: 100%;
  align-content: center;
}

.header-subtitle {
  color: #0a4488;
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0;
}

.custom-chip {
  height: 29px;
  max-height: 28px;
  justify-content: center;
  width: 211px;
}

/* Desktop (padrão) */
/* Nada muda aqui */

/* Tablets */
@media (max-width: 1024px) {
  .image-background {
    width: 120%;
    height: 120%;
  }
}

/* Celulares */
@media (max-width: 600px) {
  .header-wrapper {
    height: 360px;
    min-height: 360px;
  }

  .header-title {
    font-size: 24px;
  }

  .header-subtitle {
    font-size: 14px;
  }

  .image-background {
    width: 150%;
    height: 150%;
  }

  .content-bottom-center {
    bottom: 10%;
  }

  .custom-chip {
    width: 180px;
  }

  .text-chip {
    font-size: 12px;
  }
}

/* Celulares pequenos */
@media (max-width: 375px) {
  .header-title {
    font-size: 20px;
  }

  .header-subtitle {
    font-size: 12px;
  }

  .custom-chip {
    width: 160px;
  }

  .text-chip {
    font-size: 10px;
  }
}

/* Celulares muito pequenos */
@media (max-width: 320px) {
  .header-title {
    font-size: 16px;
  }

  .header-subtitle {
    font-size: 10px;
  }

  .custom-chip {
    width: 140px;
  }

  .text-chip {
    font-size: 8px;
  }
}

</style>
